/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Resource } from './Resource';
import {
    ResourceFromJSON,
    ResourceFromJSONTyped,
    ResourceToJSON,
    ResourceToJSONTyped,
} from './Resource';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * 
 * @export
 * @interface BackMatter
 */
export interface BackMatter {
    /**
     * 
     * @type {string}
     * @memberof BackMatter
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof BackMatter
     */
    id?: number;
    /**
     * 
     * @type {Array<Resource>}
     * @memberof BackMatter
     */
    resources?: Array<Resource>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof BackMatter
     */
    links?: Array<Link>;
}

/**
 * Check if a given object implements the BackMatter interface.
 */
export function instanceOfBackMatter(value: object): value is BackMatter {
    return true;
}

export function BackMatterFromJSON(json: any): BackMatter {
    return BackMatterFromJSONTyped(json, false);
}

export function BackMatterFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackMatter {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'resources': json['resources'] == null ? undefined : ((json['resources'] as Array<any>).map(ResourceFromJSON)),
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(LinkFromJSON)),
    };
}

export function BackMatterToJSON(json: any): BackMatter {
    return BackMatterToJSONTyped(json, false);
}

export function BackMatterToJSONTyped(value?: BackMatter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'resources': value['resources'] == null ? undefined : ((value['resources'] as Array<any>).map(ResourceToJSON)),
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(LinkToJSON)),
    };
}

